import { Directive, HostListener, Optional } from '@angular/core';
import { AuthService, Labels, Permissions, ProjectMetaData, Tracking } from '@sew/ui-components';
import {
    HeaderConfigService,
    HeaderLoginService,
    OsApiAuthService,
    TrackingService,
    User,
} from '../../services/public-services';

interface CustomEvent<T> {
    detail: T;
}

@Directive({
    selector: '[oscHeaderEvents]',
    standalone: false,
})
export class HeaderEventsDirective {
    public constructor(
        private configService: HeaderConfigService,
        private loginService: HeaderLoginService,
        private authService: OsApiAuthService,
        @Optional() private trackingService: TrackingService
    ) {}

    @HostListener('languageSwitch', ['$event'])
    public languageSwitch(event: CustomEvent<string>) {
        this.configService.setLanguage(event.detail);
    }

    @HostListener('countryShort', ['$event'])
    public countryShort(event: CustomEvent<string>) {
        this.configService.setCountryShort(event.detail);
    }

    @HostListener('cmsProject', ['$event'])
    public cmsProject(event: CustomEvent<string>) {
        this.configService.setCmsProject(event.detail);
    }

    @HostListener('userChange', ['$event'])
    public userChange(event: CustomEvent<User>) {
        this.loginService.setUser(event.detail);
    }

    @HostListener('initComplete', ['$event'])
    public initComplete() {
        this.configService.setInitComplete();
    }

    @HostListener('labelsChange', ['$event'])
    public labelsChange(event: CustomEvent<Labels>) {
        this.configService.setLabels(event.detail);
    }

    @HostListener('projectMetaDataChange', ['$event'])
    public projectMetaDataChange(event: CustomEvent<ProjectMetaData>) {
        this.configService.setProjectMetaData(event.detail);
    }

    @HostListener('permissionChange', ['$event'])
    public userPermissionChange(event: CustomEvent<Permissions>) {
        this.configService.setPermissions(event.detail);
    }

    @HostListener('getTrackingService', ['$event'])
    public getTrackingService(event: CustomEvent<Tracking>) {
        if (this.trackingService !== null) {
            this.trackingService.setTracker(event.detail);
        }
    }

    @HostListener('authInstance', ['$event'])
    public async getAuthService(event: CustomEvent<AuthService>) {
        this.authService.setAuth(event.detail as AuthService);
    }
}
